import styled from 'styled-components'
import { Grid as BaseGrid } from '@material-ui/core'

export const Container = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.white};
  border-radius: 8px;
  display: flex;
  max-width: 900px;
  min-height: 360px;
  padding: 0 126px;
  text-align: center;

  ${props => props.theme.breakpoints.down('sm')} {
    padding: 0 20px;
  }
`

export const Root = styled(BaseGrid)`
  background: ${props => props.theme.palette.gray[90]};
  height: 100vh;
  width: 100%;
`

export const Wrapper = styled.div`
  width: 100%;
`
